import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
// import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_one, fetch_all } from "../../lib/v31lib";
// import { loginAtom } from '../../lib/auth';
// import { currentPracticeAtom } from '../../lib/practice';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import GridViewIcon from '@mui/icons-material/GridView';
import LockIcon from '@mui/icons-material/Lock';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import NotificationsIcon from '@mui/icons-material/Notifications';

import {
  Box,
  Divider,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Page,
  // Typography
} from '../../components/v2/styled';
import { ClientSettingsAccount } from './settings/Account';
import { ClientSettingsConsents } from './settings/Consents';
import { ClientSettingsDashboard } from './settings/Dashboard';
import { ClientSettingsNotifications } from './settings/Notifications';
import { ClientSettingsNutriMail } from './settings/NutriMail';
import { ClientSettingsSecurity } from './settings/Security';

// const { DateTime } = require("luxon");

type Props = {}

export const ClientSettings: FunctionComponent<Props> = ({}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  const { state } = useLocation();

  const [currentTab, setCurrentTab] = useState<number>(!!state && !!state.tab ? state.tab : 0);
  // open_body -> intake

  // open_advice: advice.id,
  // active_advice: advice

  // open_treatment_plans: treatmentPlans.custom_result[0].id, 
  // active_treatment_plan: treatmentPlans.custom_result[0]

  return <Page>
    <Box>
      <Box sx={{
        marginBottom: 3,
        '& .Mui-selected': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }
      }}>
        <Tabs
          value={currentTab}
          onChange={(e, v) => {setCurrentTab(v);}}
          indicatorColor="primary"
          textColor="primary"
          aria-label="Filters"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab icon={<AccountCircleIcon />} label={t("client.settings.account.title")} />
          <Tab icon={<LockPersonIcon />} label={t("client.settings.consents.title")} />
          <Tab icon={<EmailIcon />} label={t("client.settings.nutri_mail.title")} />
          <Tab icon={<NotificationsIcon />} label={t("client.settings.notifications.title")} />
          <Tab icon={<GridViewIcon />} label={t("client.settings.dashboard.title")} />
          <Tab icon={<LockIcon />} label={t("client.personal_settings.security.title")} />
        </Tabs>
        <Divider sx={{borderColor: theme.palette.primary.main}} />
      </Box>


      {currentTab === 0 && <ClientSettingsAccount />}
      {currentTab === 1 && <ClientSettingsConsents hardRefresh={!!state && state.refresh === 'hard'} />}
      {currentTab === 2 && <ClientSettingsNutriMail />}
      {currentTab === 3 && <ClientSettingsNotifications />}
      {currentTab === 4 && <ClientSettingsDashboard />}
      {currentTab === 5 && <ClientSettingsSecurity />}
    </Box>
  </Page>;
}

